import {
  DELETE_SLACK_STATUS_INTEGRATION_REQUEST,
  DELETE_SLACK_STATUS_INTEGRATION_SUCCESS,
  DELETE_SLACK_STATUS_INTEGRATION_FAILURE,
  DELETE_SLACK_CHAT_INTEGRATION_REQUEST,
  DELETE_SLACK_CHAT_INTEGRATION_SUCCESS,
  DELETE_SLACK_CHAT_INTEGRATION_FAILURE
} from '../actions/integrations';

const integrations = (state = [], action) => {
  switch (action.type) {
    case DELETE_SLACK_STATUS_INTEGRATION_REQUEST:
      return {
        ...state
      };
    case DELETE_SLACK_STATUS_INTEGRATION_SUCCESS:
      return {
        ...state,
        integration: action.integration,
        error: false
      };
    case DELETE_SLACK_STATUS_INTEGRATION_FAILURE:
      return {
        ...state,
        error: true
      };
    case DELETE_SLACK_CHAT_INTEGRATION_REQUEST:
      return {
        ...state
      };
    case DELETE_SLACK_CHAT_INTEGRATION_SUCCESS:
      return {
        ...state,
        integration: action.integration,
        error: false
      };
    case DELETE_SLACK_CHAT_INTEGRATION_FAILURE:
      return {
        ...state,
        error: true
      };
    default:
      return state;
  }
};

export default integrations;



// WEBPACK FOOTER //
// ./src/reducers/integrations.js